var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe210Large(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M39 23c0-8.836-7.164-16-16-16S7 14.164 7 23s7.164 16 16 16 16-7.164 16-16zm-2 8.058H9m30-8H7m30-8H9m8.74 23.04C14.7 34.47 12.764 29.057 12.764 23c0-6.058 1.934-11.472 4.974-15.098m0 0c-3.04 3.625-4.974 9.04-4.974 15.097 0 6.058 1.934 11.47 4.974 15.098M28.262 7.904c3.04 3.624 4.972 9.04 4.972 15.096 0 6.058-1.932 11.47-4.972 15.098m0 0c3.04-3.627 4.972-9.04 4.972-15.097 0-6.058-1.932-11.472-4.972-15.098M23 7v32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe210Large);
export default __webpack_public_path__ + "static/media/globe_210_large.e82f1405654c9cb637d65b1e5b00fdcd.svg";
export { ForwardRef as ReactComponent };